<script>
/*
TODO: 文字数指定の対応
TODO: 数値のみを受け付ける処理の追加(<el-input-number>を使用するか未定)
TODO: 親コンポーネント側でのエラーをテキストボックスのエラーメッセージに表示する
TODO: テストコード作成
*/
export default {
    model: {
        prop: 'inputValue',
        event: 'update:inputValue',
    },

    // ========== props ==========
    props: {
        inputValue: String,
        label: String,
        prop: String,
        disable: {
            type: Boolean,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        // large, default, small
        size: {
            type: String,
            required: false,
        },
        customClass: {
            type: String,
            default: '',
            required: false,
        },
        placeholder: {
            type: String,
            default: '',
            required: false,
        },
        clearable: {
            type: Boolean,
            default: false,
            required: false,
        },
        maxLength: {
            type: Number,
            default: null,
            required: false,
        }
    },

    // ========== methods ==========
    methods: {
        onInput(value) {
            this.$emit('update:inputValue', value)
            this.$emit('input', value)
        }
    }
}
</script>

<template>
  <el-form-item :label="label" :prop="prop">
    <template #label>
        {{ label }}
    </template>
    <el-input
      :value="inputValue"
      :disabled="disable"
      type="text"
      :maxlength="maxLength"
      @input="onInput"
      :placeholder="placeholder"
      :clearable="clearable"
    >
      <template #prefix>
        <slot name="prefix" />
      </template>
      <template #suffix>
        <slot name="suffix" />
      </template>
    </el-input>
  </el-form-item>
</template>

<style scoped>
:deep() .el-form-item__label::before {
  display: none;
}
</style>
